module.exports = __webpack_public_path__ + "img/NewsArticlesComingSoon-Mobile.bff000a9.png";